export default __webpack_public_path__ + "static/media/GRE.78071ba6.png";